<div class="holidays container m-0 p-0">
  <div class="row">
    <div class="col dialog-title">Holidays</div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <div [formGroup]="form">
        <div class="modal__item row">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'name'"
            [touched]="form.get('name')!.touched"
            >Name
          </label>
          <div class="col-8 modal-validation">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="name"
            />
            <app-error-field
              [displayError]="
                isFieldInvalid('name', form) &&
                form.get('name')!.hasError('required')
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="form.get('name')!.hasError('maxlength')"
              [errorMessage]="'Max field length = 40'"
            ></app-error-field>
          </div>
        </div>
        <div class="modal__item row">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'date'"
            [touched]="form.get('date')!.touched"
            >Date
          </label>
          <div class="col-8 modal-validation">
            <app-datepicker
              [iconLeft]="true"
              formControlName="date"
              [staticPropery]="true"
            ></app-datepicker>
            <app-error-field
              [displayError]="isFieldInvalid('date', form)"
              [errorMessage]="'The field is required'"
            ></app-error-field>
          </div>
        </div>
        <div class="modal__item row">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'comment'"
            [touched]="form.get('comment')!.touched"
            >Comment</label
          >
          <div class="col-8 input__wrapper">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="comment"
            />
            <app-error-field
              [displayError]="form.get('comment')!.hasError('wordCount')"
              [errorMessage]="'Max field length = 400 words'"
            ></app-error-field>
          </div>
        </div>
      </div>
      <img
        class="interview__trash icon"
        src="assets/icons/svg/trash/ion_trash-bin.svg"
        alt="trash"
        *ngIf="form.controls['id'].value"
        (click)="deleteHoliday()"
      />
    </div>
  </div>

  <div class="row align-items-center justify-content-end dialog-buttons">
    <div class="col-auto p-0 mb-3">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
